import { Amplify } from 'aws-amplify';
import { environment } from 'src/environment';
import { LOCALHOST_GRAPHQL_URL } from '$shared/utils/api-paths';

// TODO: it is really inconvenient that the FE needs this information (userPoolId, userPoolWebClientId etc.)
// i'm thinking more and more that a server side rendered solution would be a more appropriate
// way. An amplify based infrastructure would handle this for us.
// Also: This approach ends up in a one to one mapping between a frontend instance and an organisation/tenant.
// I think that is not what we want and probably won't scale.
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.PUBLIC_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.PUBLIC_COGNITO_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.PUBLIC_COGNITO_OAUTH_DOMAIN,
          scopes: ['email', 'openid', 'profile', 'api/backoffice.write', 'api/backoffice.read'],
          redirectSignIn: [window.location.origin],
          redirectSignOut: [window.location.origin],
          responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
        },
      },
    },
  },
  API: {
    GraphQL: {
      endpoint: environment.graphqlUrl || LOCALHOST_GRAPHQL_URL,
      region: import.meta.env.PUBLIC_AWS_REGION,
      defaultAuthMode: 'userPool',
    },
  },
});
